exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-icon[data-v-da36b5ea] {\n  width: 64px;\n  height: 64px;\n  border: solid 2px #d99;\n  border-radius: 50%;\n  background: white;\n  cursor: pointer;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.close-button[data-v-da36b5ea] {\n  position: absolute;\n  top: -6px;\n  right: -1px;\n  color: white;\n}\n.img-icon-select[data-v-da36b5ea] {\n  border: solid 2px red;\n  -webkit-animation: blink-data-v-da36b5ea 0.5s ease-in-out infinite alternate;\n  animation: blink-data-v-da36b5ea 0.5s ease-in-out infinite alternate;\n}\n@-webkit-keyframes blink-data-v-da36b5ea {\n0% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n@keyframes blink-data-v-da36b5ea {\n0% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-da36b5ea","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/VirtualOffice/Member.vue
// module id = qCfY
// module chunks = 0